import { useMemo } from "react";
import { WorkList } from "../store/types/work.types";
import { WorksFilters } from "../types/WorksList.types";
import { parseISO } from "date-fns";

export function useWorksFilters(
  works: WorkList[],
  filters: WorksFilters
): WorkList[] {
  return useMemo(() => {
    let filtered = [...works];

    // Search filter
    if (filters.search.trim()) {
      const search = filters.search.toLowerCase();
      filtered = filtered.filter(
        (w) =>
          w.Name?.toLowerCase().includes(search) ||
          w.Customer?.Name?.toLowerCase().includes(search) ||
          w.Description?.toLowerCase().includes(search) ||
          w.Team?.Name?.toLowerCase().includes(search)
      );
    }

    // WorkType filter
    if (filters.workTypes.length > 0) {
      filtered = filtered.filter((w) => filters.workTypes.includes(w.Type));
    }

    // Date filter
    if (filters.dateFilter.from || filters.dateFilter.to) {
      filtered = filtered.filter((w) => {
        if (!w.Modified) return false;
        const modified = parseISO(w.Modified);
        if (filters.dateFilter.from && modified < filters.dateFilter.from) {
          return false;
        }
        if (filters.dateFilter.to) {
          const toEnd = new Date(filters.dateFilter.to);
          toEnd.setHours(23, 59, 59, 999);
          if (modified > toEnd) return false;
        }
        return true;
      });
    }

    // Sort by Modified descending
    filtered.sort(
      (a, b) =>
        new Date(b.Modified).getTime() - new Date(a.Modified).getTime()
    );

    return filtered;
  }, [works, filters]);
}
